<template>
  <v-app>
    <v-container
      grid-list-md
      text-center>
      <v-layout
        row
        wrap>
        <v-container
          text-left>
           <v-alert
           close-text="Close Alert"
          outlined
          dismissible two-line

          >

    <h3>Welcome{{user.info.name ? " " + user.info.name : ""}}!</h3>
    <p class='font-weight-light subtitle text--darken-3 grey--text mt-5'> Congratulations on signing up for your My Genetic Trust; we’re here to help you along the way. Here’s a quick guide to the steps of the process to help you determine what to do next.
    </p>
    <p v-if='!user.complete' class='font-weight-light subtitle text--darken-3 grey--text mt-5 mt-5'>Begin by clicking on <router-link to="/questionnaire">Intake</router-link> to start collecting your information for your My Genetic Trust custom report. Your progress will automatically save as you record information, so you can log in and out as often as you’d like.</p>
    <div v-else class='mt-5'>
     
   
       <v-alert>
     1. <b>To Get Started:</b> Click on <router-link to="/questionnaire">Intake</router-link> to start filling out your personal medical and family history information. We have Tips for <router-link to="/familyHistoryCollection">Family History Collection</router-link>, Tips for <router-link to="/medicalRecordsCollectionGuide">Medical Record Collection</router-link>, and a <router-link to="/FamilyTreeWorksheet">Family History Worksheet</router-link> to help make the process easier.
    </v-alert>
        <v-alert>
     2. <b>To Submit:</b> After you’ve got all your medical and family history information completed, click  <v-chip
              class="white--text ml-0"
              color="green"
              label
              small
            >
              Submit
            </v-chip> to send your information to be reviewed by a certified genetic counselor.
    </v-alert>
    <v-alert>
     3. <b>To Access Your Report and Medical Records:</b> After your My Genetic Trust report has been generated, you can view it by clicking <router-link to="/report">Report</router-link>; see the medical records that are a part of your Trust by clicking <router-link to="/report">Medical Records</router-link>.

    </v-alert>
    <v-alert>
     4. <b>To Make Changes:</b> After you submit more information and update your profile, click the <v-chip
              class="white--text ml-0"
              color="green"
              label
              small
            >
              Save
            </v-chip> button. Once you’ve entered all your updates, click <v-chip
              class="white--text ml-0"
              color="green"
              label
              small
            >
              Resubmit
            </v-chip> and a genetic counselor will review your new information and update your My Genetic Trust report.

    </v-alert>
   
    </div>
           </v-alert>

           <v-row
      
    >
      <v-col cols="12">
         <v-stepper alt-labels :value="progress">
    <v-stepper-header>
      <v-stepper-step  step="1" :complete='complete1'>Complete Medical History Intake
</v-stepper-step>
      <v-divider></v-divider>
      <v-stepper-step step="2" :complete='complete2'>Complete Family History Intake
      </v-stepper-step>
      <v-divider></v-divider>

      <v-stepper-step step="3" :complete='complete3'>Information Submitted, Under Review</v-stepper-step>
       <v-divider></v-divider>
<v-stepper-step step="4" :complete='false'>Report Generated!</v-stepper-step>
    </v-stepper-header>
  </v-stepper>
      </v-col>
     
    </v-row>
  
        </v-container>

        <template v-for="(item, i) in menuData">
          <v-flex
            v-if="surveyCheck(item)"
            :key="i"
            xs6
            sm3>
            <v-hover v-slot:default="{ hover }">
              <v-card
                :disabled='item.isDisabled'
                class='mainHov mt-8'
                color='primary'
                :to='item.link'
                :elevation="hover ? 12 : 2"
                :class="{ 'on-hover': hover }"
                height='230px'>
                <img
                  class='mt-12'
                  :src='item.src'/>
                <v-card-title class="title white--text fill-height">
                  <v-layout
                    fill-height
                    column
                    justify-space-between>
                    <p
                      style='z-index:90'
                      class="mt-4 subheading text-center">{{ item.title }}</p>
                  </v-layout>
                </v-card-title>
              </v-card>
            </v-hover>
          </v-flex>
        </template>
      </v-layout>
    </v-container>

    <v-layout justify-center>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">User Profile</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-form
                v-model='validForm'>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field
                      :rules="nameRules"
                      v-model='user.info.name'
                      label="Name*"
                      required>{{user.info.name}}</v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      :rules="emailRules"
                      v-model='user.info.email'
                      label="Email*"
                      readonly
                      required>{{user.info.email}}</v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      :rules="phoneRules"
                      v-model='user.info.phone'
                      label="Phone*"
                      required>{{user.info.phone}}</v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    <v-text-field
                      :rules="faxRules"
                      v-model='user.info.fax'
                      label="Fax"
                      required>{{user.info.fax}}</v-text-field>
                  </v-flex>

                  <v-flex xs12>
                    Address
                    <div>
                      <div class="flex mb-4">
                        <div>
                          <v-text-field
                            label="Street"
                            v-model='user.info.address.street'
                            required></v-text-field>
                        </div>
                      </div>
                      <v-layout
                        row
                        wrap>
                        <v-flex
                          xs12
                          sm4>
                          <v-text-field
                            label="City"
                            v-model='user.info.address.city'
                            required></v-text-field>
                        </v-flex>
                        <v-flex
                          xs12
                          sm4>
                          <v-text-field
                            label="State"
                            v-model='user.info.address.state'
                            required></v-text-field>
                        </v-flex>
                        <v-flex
                          xs12
                          sm4>
                          <v-text-field
                            label="Zip Code"
                            v-model='user.info.address.zip'
                            required></v-text-field>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-container>

            <small>*indicates required field</small>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              :disabled='!validForm'
              color="primary"
              text
              @click="saveToDB(),dialog = false">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-app>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { editUserData} from '@/helper/firestore'
export default {
  data () {
    return {
      complete1 : false,
      complete2 : false,
      complete3 : false,
      progress: 0,
      menuData: [
        { title: "Intake", src: require("@/assets/intake.png"), link: "questionnaire" },
         { title: "Upload Documents", src: require("@/assets/upload.png"), link: "upload" },
        { title: "Health History Summary", src: require("@/assets/medical-history.png"), link: "healthhistory" },
        { title: "Family History Summary", src: require("@/assets/inheritance.png"), link: "familyHistory" },
        { title: "Report", src: require("@/assets/business-report-64.png"), link: "report" },
        { title: "Message Center", src: require("@/assets/online.png"), link: "messaging" },
        { title: "Resources", src: require("@/assets/manual.png"), link: "resources"},
       
        { title: "My Account", src: require("@/assets/shield.png"), link: "account" },
        
      ],
      surveyBlockedRoutes: [
        "healthhistory",
        "familyHistory"
      ],
      valid: true,
      fieldRules: [
        v => !!v || 'this field is required'
      ],
      dialog: false,
      validForm: false,
      nameRules: [
        v => !!v || 'A name is required'
      ],
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      phoneRules: [
        v => !!v || 'A phone number is required',
        v => /^[^A-z]/.test(v) || 'Please enter a valid phone number'
      ],
      faxRules: [
        v => /^[^A-z]/.test(v) || /^.{0}$/.test(v) || 'Please enter a valid fax number'
      ],
      zipRules: [
        v => /^[0-9]{5}(?:-[0-9]{4})?$/.test(v) || 'Please enter a valid zipcode'
      ],
    }
  },
  mounted () {
    this.determineStep();
    this.isPublic = false
    if (this.user.info.name === '') {
      if (typeof this.user.info.address === 'string') {
        this.user.info.address = {
          street: '',
          city: '',
          state: '',
          zip: ''
        }
      }
      this.dialog = true
    }
  },
  components: {

  },
  methods: {
    determineStep(){
      if(this.user.adminReviewStage && this.user.adminReviewStage === "completed") {
        this.progress = 3;
        this.complete1 = true
        this.complete2 = true
        this.complete3 = true
      }else{
         if (this.user.complete) {
           this.progress = 2 
        this.complete1 = true
        this.complete2 = true
        this.complete3 = false
         }else{
           this.progress = 1
        this.complete1 = true
        this.complete2 = false
        this.complete3 = false
         } 
      }
     
      
    },
    saveToDB() {
      editUserData(this.user.info, (data) => {
        if (data.status === 200) {
          this.snackBarType = "success"
          this.snackBarshow = true
          this.snackBarmessage = "Update complete"
        } else {
          this.snackBarType = "warning"
          this.snackBarshow = true;
          this.snackBarmessage = "Update failed";
        }
      })
    },
    onboarding () {
      // need to fetch user data from firestore not from the identity platform
      editUserData(this.user.idToken, this.user, () => {
        this.snackBarType = "success";
        this.snackBarshow = true;
        this.snackBarmessage = "Update complte";
        this.overlay = false;
      })
    },
    surveyCheck(item) {
      return !this.surveyBlockedRoutes.includes(item.link) || this.user.complete;
    },
    autoLogout () {
      if (this.isAppIdle === true) {
        window.location.reload();
      }
    }
  },
  computed: {
    computeMessageCount(){
      return this.messages.filter(message => {return message.read === false}).length;
    },
    ...mapFields([
      'messages',
      'messagesCount',
      'isAuthorized',
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
      'overlay',
      'isPublic'
    ]),
    messageStr () {
      if (this.isAppIdle === true) {
        alert("Session timeout...")
        this.autoLogout()
      }
      return this.isAppIdle
    }
  },
}
</script>
<style scoped>
.mainHov {
  transition: opacity 0.4s ease-in-out;
}

.mainHov:not(.on-hover) {
  opacity: 0.8;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>
